import type { EdgeDefinition } from './base-crm';

export const PEVC_FUNDRAISING_EDGES: Record<string, EdgeDefinition> = {
  // Note: OPPORTUNITY_FOR is defined in sales.ts but also applies to FundraisingOpportunity
  // It's included there with both Opportunity and FundraisingOpportunity as sourceTypes
  // Note: FundraisingOpportunity → InvestmentAccount/Commitment relationship
  // is handled by ORIGINATED_FROM in pevc-ir.ts
  // (InvestmentAccount/Commitment → FundraisingOpportunity, reverse: "Led To")
};
